import { all, takeLatest, takeEvery } from 'redux-saga/effects';

import { ProductTypes } from '../ducks/product';
import { AuthTypes } from '../ducks/auth';
import { CourseTypes } from '../ducks/course';
import { CommentsTypes } from '../ducks/comments';
import { UserProfileTypes } from '../ducks/userProfile';
import { AnnotationsTypes } from '../ducks/annotations';
import { AppointmentsTypes } from '../ducks/appointments';

import { sagasErrorInterceptor } from './sagasError';
import { getConfig } from './product';
import * as sagasAuth from './auth';
import * as sagasCourse from './course';
import * as sagasLesson from './lesson';
import * as sagasUser from './userProfile';
import * as sagasComments from './comments';
import * as sagasNotes from './annotations';
import * as sagasAppointments from './appointments';

export default function* rootSaga() {
  yield all([
    yield takeEvery('ERROR_HANDLER', sagasErrorInterceptor),
    // Product
    yield takeLatest(ProductTypes.REQUEST_CONFIG, getConfig),
    // Authentication
    yield takeLatest(AuthTypes.CHECK_AUTH, sagasAuth.checkAuth),
    yield takeLatest(AuthTypes.REQUEST_LOGIN, sagasAuth.login),
    yield takeLatest(AuthTypes.REQUEST_LOGIN_BY_GUID, sagasAuth.loginByGuid),
    // Course
    yield takeLatest(AuthTypes.LOGOUT, sagasAuth.logout),
    yield takeLatest(
      CourseTypes.REQUEST_COURSES_LIST,
      sagasCourse.getCoursesList,
    ),
    yield takeEvery(CourseTypes.REQUEST_COURSE, sagasCourse.getCourse),
    yield takeLatest(
      CourseTypes.REQUEST_NEXT_LESSON,
      sagasCourse.getNextLesson,
    ),
    yield takeLatest(
      CourseTypes.REQUEST_LESSON_FILES,
      sagasLesson.getFilesLesson,
    ),
    yield takeLatest(
      CourseTypes.REQUEST_LESSON_QUESTIONS,
      sagasLesson.getQuestionsLesson,
    ),
    yield takeLatest(
      CourseTypes.REQUEST_CERTIFICATE_HTML,
      sagasCourse.getCertificateHtml,
    ),
    yield takeLatest(
      CourseTypes.REGISTER_LESSON_ACCESSED,
      sagasLesson.registerLessonAccessed,
    ),
    yield takeEvery(
      CourseTypes.SET_LESSON_ANSWERS,
      sagasLesson.setLessonAnswers,
    ),
    yield takeLatest(
      CourseTypes.SET_LESSON_COMPLETED,
      sagasLesson.setLessonCompleted,
    ),
    // Comments
    yield takeLatest(
      CommentsTypes.REQUEST_STUDENT_COMMENTS,
      sagasComments.listStudentComments,
    ),
    yield takeLatest(
      CommentsTypes.REQUEST_LESSON_COMMENTS,
      sagasComments.listLessonComments,
    ),
    yield takeLatest(
      CommentsTypes.REQUEST_STORE_COMMENT,
      sagasComments.storeComment,
    ),
    yield takeLatest(
      CommentsTypes.REQUEST_UPDATE_COMMENT,
      sagasComments.updateComment,
    ),
    yield takeLatest(
      CommentsTypes.REQUEST_REMOVE_COMMENT,
      sagasComments.removeComment,
    ),
    // Annotations
    yield takeLatest(
      AnnotationsTypes.REQUEST_ALL_ANNOTATIONS,
      sagasNotes.listAllAnnotations,
    ),
    yield takeLatest(
      AnnotationsTypes.REQUEST_LESSON_ANNOTATIONS,
      sagasNotes.listByLessonAnnotations,
    ),
    yield takeLatest(
      AnnotationsTypes.REQUEST_STORE_ANNOTATION,
      sagasNotes.storeAnnotation,
    ),
    yield takeLatest(
      AnnotationsTypes.REQUEST_UPDATE_ANNOTATION,
      sagasNotes.updateAnnotation,
    ),
    yield takeLatest(
      AnnotationsTypes.REQUEST_REMOVE_ANNOTATION,
      sagasNotes.removeAnnotation,
    ),
    // User
    yield takeLatest(
      UserProfileTypes.GET_USER_PROFILE,
      sagasUser.getUserProfile,
    ),
    yield takeLatest(UserProfileTypes.UPDATE_PROFILE, sagasUser.updateProfile),
    yield takeLatest(UserProfileTypes.CLEAR_STATUS, sagasUser.clearStatus),
    yield takeLatest(
      UserProfileTypes.UPDATE_PASSWORD,
      sagasUser.updatePassword,
    ),
    yield takeLatest(
      UserProfileTypes.RECOVER_USER_PASSWORD,
      sagasUser.recoverPassword,
    ),
    yield takeLatest(UserProfileTypes.UPDATE_AVATAR, sagasUser.updateAvatar),
    yield takeLatest(UserProfileTypes.REMOVE_AVATAR, sagasUser.removeAvatar),
    yield takeLatest(
      UserProfileTypes.GET_USER_FIRST_ACCESS,
      sagasUser.getUserFirstAccess,
    ),
    yield takeLatest(
      UserProfileTypes.SAVE_FIRST_ACCESS_LOG,
      sagasUser.saveFirstAccessLog,
    ),
    yield takeLatest(
      UserProfileTypes.CAN_USER_RESET_PASSWORD,
      sagasUser.canUserResetPassword,
    ),
    yield takeLatest(
      UserProfileTypes.RESET_USER_PASSWORD,
      sagasUser.resetUserPassword,
    ),
    yield takeLatest(
      UserProfileTypes.FORCE_OPEN_WELCOME_MODAL,
      sagasUser.forceOpenWelcomeModal,
    ),
    yield takeLatest(
      UserProfileTypes.GET_ACCESS_PROFILES,
      sagasUser.getAccessProfiles,
    ),
    // Appointments
    yield takeLatest(
      AppointmentsTypes.REQUEST_INFOS,
      sagasAppointments.getAppointmentInfos,
    ),
    yield takeLatest(
      AppointmentsTypes.REQUEST_APPOINTMENTS,
      sagasAppointments.getAppointments,
    ),
    yield takeLatest(
      AppointmentsTypes.REQUEST_CANCEL_APPOINTMENT,
      sagasAppointments.cancelAppointment,
    ),
    yield takeLatest(
      AppointmentsTypes.REQUEST_PROFESSIONALS,
      sagasAppointments.getProfessionals,
    ),
    yield takeLatest(
      AppointmentsTypes.REQUEST_PROFESSIONAL,
      sagasAppointments.getProfessional,
    ),
    yield takeLatest(
      AppointmentsTypes.REQUEST_STORE_RATING,
      sagasAppointments.storeRating,
    ),
    yield takeLatest(
      AppointmentsTypes.REQUEST_SCHEDULE_TIME_TABLE,
      sagasAppointments.getScheduleTimeTable,
    ),
    yield takeEvery(
      AppointmentsTypes.REQUEST_SCHEDULE_COLUMNS,
      sagasAppointments.getScheduleColumns,
    ),
    yield takeLatest(
      AppointmentsTypes.SEND_APPOINTMENT,
      sagasAppointments.storeAppointment,
    ),
  ]);
}
